module.exports = __webpack_public_path__ + "img/saba-island.f2e8f72b.png";